module.exports = __webpack_public_path__ + "static/media/workingmemory-words-2.e1d068c9.mp3";